import graphql from "babel-plugin-relay/macro";
import { fetchQuery } from "react-relay";

import { environment } from "pstat-anywhere/relay";

const getCategoryDefaultFlowTemplateQuery = graphql`
  query getCategoryDefaultFlowTemplateQuery($categoryPk: Int!) {
    getCategoryDefaultFlowTemplate(categoryPk: $categoryPk) {
      pk
      name
    }
  }
`;

const getCategoryDefaultFlowTemplate = (
  categoryPk,
  setFlowTemplate,
  requestId,
  currentRequestRef
) => {
  const variables = {
    categoryPk
  };
  fetchQuery(environment, getCategoryDefaultFlowTemplateQuery, variables).then(
    data => {
      if (requestId !== currentRequestRef.current) {
        return;
      }
      if (!data) {
        return;
      }
      const flowTemplate = data.getCategoryDefaultFlowTemplate;
      setFlowTemplate(flowTemplate ? flowTemplate.pk : null);
    }
  );
};

export default getCategoryDefaultFlowTemplate;
